import request from '@/utils/request'

export function listFee(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/fee.listFee',
			method: 'get',
			params
		}).then(response => {
			const res = response.data
			resolve(res)

		}).catch(error => {
			reject(error)
		})
	})
}

export function listFeeConfigs(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/feeConfig.listFeeConfigs',
			method: 'get',
			params
		}).then(response => {
			const res = response.data
			resolve(res)

		}).catch(error => {
			reject(error)
		})
	})
}

export function listMonthFee(params) {
	return new Promise((resolve, reject) => {
		request({
			url: '/fee.listMonthFee',
			method: 'get',
			params
		}).then(response => {
			const res = response.data
			resolve(res)

		}).catch(error => {
			reject(error)
		})
	})
}
export function groupByYearMonthWithMap(data) {
	const groups = new Map();

	data.forEach(item => {
		const yearMonth = normalizeToYYYYMM(item);
		
		// 可选：跳过无效值
		if (yearMonth == null) return;

		if (!groups.has(yearMonth)) {
			groups.set(yearMonth, []);
		}
		groups.get(yearMonth).push(item);
	});
	
	
	// 按年月升序排序（"YYYY-MM" 格式天然支持 localeCompare）
	const sortedEntries = Array.from(groups.entries()).sort(([a], [b]) =>
		a.localeCompare(b)
	);

	const sortedMap = new Map(sortedEntries);
	return Object.fromEntries(sortedMap);
}

function normalizeToYYYYMM(item) {
  // 优先尝试 yearAndMonth 字段
  if (typeof item.yearAndMonth === 'string') {
    const trimmed = item.yearAndMonth.trim();
    const match = trimmed.match(/^(\d{4})[-/](\d{1,2})$/);
    if (match) {
      const year = match[1];
      const month = String(Number(match[2])).padStart(2, '0');
      return `${year}-${month}`;
    }
  }

  // fallback：用 detailYear + detailMonth 拼接
  const y = item.detailYear;
  const m = item.detailMonth;
  if (y && m) {
    const year = String(y).trim();
    const month = String(m).trim().padStart(2, '0');
    return `${year}-${month}`;
  }

  return null;
}


